__turbopack_context__.v({
  "cell": "sPpNiW_cell",
  "content": "sPpNiW_content",
  "empty": "sPpNiW_empty",
  "table-block": "sPpNiW_table-block",
});
